import { Component, OnInit, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { IItem } from '@coreui/angular-pro'
import { Router } from '@angular/router';
import { CountryNames, IncomeSourcesValue, DecisionParameters, CreateInvitation } from 'src/app/interfaces/apiresponses';
import { RestService } from 'src/app/services/rest/rest.service';
import { DatePipe } from '@angular/common';
import { windowWhen } from 'rxjs';

@Component({
  selector: 'app-invitations',
  templateUrl: './invitations.component.html',
  styleUrls: ['./invitations.component.scss'],
  providers: [DatePipe]

})
export class InvitationsComponent {
  invitationForm!: FormGroup
  minDateOfBirth: Date = new Date()
  minIDExpiryDate: Date = new Date()
  decisionTable: any = []
  dialCode:any
  selectedItems = [2, 3];
  // Country list
  countryList: CountryNames | undefined
  bNewCustomer: boolean = false
  showInvitationdata: boolean = false
  showInvitationdataMultiple: boolean = false;

  constructor(private restApi: RestService, private datePipe: DatePipe,
    private formBuilder: FormBuilder, private route: Router,
    private changeDetector: ChangeDetectorRef) {
  }

  selectedCustomerNationality: any;
  OnCountryList(event: any) { 
    if (event.success) { 
      this.countryList = {
        ...event.data,
        dhabiCountries: event.data.dhabiCountries.filter((country: any) => country.isEnabled)
      };
      console.log('Got country list')
    }
    else {
      this.showAlertBox('Sorry', 'Something wrong with the remote system. Please contact the support')
    }
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  numberInvitations: boolean = false
  ngOnInit() {
    this.getDecisionParameters()
    this.incomeSources()
    this.selectedCustomerNationality = 1
    let minAge = new Date()
    minAge.setFullYear(minAge.getFullYear() - 18)
    this.minDateOfBirth = minAge
  
    this.invitationForm = new FormGroup({
      isSingleDetailedInvitation: new FormControl(null, [Validators.required]),
      // numberOfInvitations: new FormControl(1,[Validators.required]),
      isInvitationChannel: new FormControl(null, [Validators.required]),
      numberOfInvitations: new FormControl(null, [Validators.required]),
      tag: new FormControl(null, [Validators.required]),
      userType: new FormControl(1),
      name: new FormControl(null),
      emailId: new FormControl(null, [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
      mobileNumber: new FormControl(null),
      dialCode: new FormControl(""),
      dateOfBirth: new FormControl(null),
      genderId: new FormControl(1),
      idType: new FormControl(0),
      idNumber: new FormControl(null),
      countryId: new FormControl(1),
      addressLine1: new FormControl(null),
      addressLine2: new FormControl(null),
      city: new FormControl(null),
      state: new FormControl(null),
      postalCode: new FormControl(null),
      sourceOfIncome: new FormControl(null),
      incomeRange: new FormControl(null),
      otherSourceOfIncome: new FormControl(null)
    })
    this.invitationForm.get('mobileNumber')?.disable();
    this.invitationForm.get('dialCode')?.valueChanges.subscribe((selectedDialCode) => {
      const mobileControl = this.invitationForm.get('mobileNumber');
      if (!selectedDialCode) {
        mobileControl?.disable();
        this.invitationForm.get('mobileNumber')?.setValue('');
      } else {
        mobileControl?.enable();
    
        const selectedCountry = this.countryList?.dhabiCountries?.find(
          (c) => c.dialCode === selectedDialCode
        );
    
        if (selectedCountry?.regexForphone) {
          const regexLength = parseInt(selectedCountry.regexForphone, 10);
          const phoneValidator = [
            Validators.required,
            Validators.minLength(selectedDialCode.length + 1),
            Validators.maxLength(regexLength),
            Validators.pattern(/^[+0-9]*$/)
          ];
          mobileControl?.setValidators(phoneValidator);
          mobileControl?.updateValueAndValidity();
        }
      }
    });
    

  }
  DecisionParameters: any = []
  DecisionParametersSources: any = []
  getDecisionParameters() {
    this.restApi.getDecisionParameters().subscribe({
      next: (v: DecisionParameters) => {
        if (v.success) {
          this.DecisionParametersSources = v.parameters[0].sources;
          this.DecisionParameters = v.parameters.map((item, UserId) => {
            const _selected = this.selectedItems.includes(UserId);
            return {
              ...item,
              _selected
            };
          })
        }
      },
      error: (e) => {

      }
    })
  }
  get name() { return this.invitationForm.get('name') }
  get emailId() { return this.invitationForm.get('emailId') }
  get isSingleDetailedInvitation() { return this.invitationForm.get('isSingleDetailedInvitation') }
  get isInvitationChannel() { return this.invitationForm.get('isInvitationChannel') }
  get numberOfInvitations() { return this.invitationForm.get('numberOfInvitations') }
  get tag() { return this.invitationForm.get('tag') }
  get userType() { return this.invitationForm.get('userType') }
  get mobileNumber() { return this.invitationForm.get('mobileNumber') }
  get dateOfBirthv() { return this.invitationForm.get('dateOfBirth') }
  get genderId() { return this.invitationForm.get('genderId') }
  get idType() { return this.invitationForm.get('idType') }
  get idNumber() { return this.invitationForm.get('idNumber') }
  get countryId() { return this.invitationForm.get('countryId') }
  get addressLine1() { return this.invitationForm.get('addressLine1') }
  get addressLine2() { return this.invitationForm.get('addressLine2') }
  get city() { return this.invitationForm.get('city') }
  get state() { return this.invitationForm.get('state') }
  get postalCode() { return this.invitationForm.get('postalCode') }
  get sourceOfIncome() { return this.invitationForm.get('sourceOfIncome') }
  get incomeRange() { return this.invitationForm.get('incomeRange') }
  get otherSourceOfIncome() { return this.invitationForm.get('otherSourceOfIncome') }

  nameValid!: boolean
  isCustomerNameValid() {
    let returnVal = ''

    if (this.name?.invalid && (this.name?.dirty || this.name?.touched)) {
      this.nameValid = false

      if (this.name?.errors?.['minlength'])
        returnVal = 'Name must be at least 2 characters long'
      else if (this.name?.errors?.['pattern'])
        returnVal = 'Only one space between words'
      else if (!this.name?.errors?.['maxLength'])
        returnVal = 'Name must be at least 60 characters long'
      else
        returnVal = 'Please enter a valid name'
    } else {
      var reg = new RegExp('^[a-zA-Z ]*$')
      if (!reg.test(this.name?.value)) {
        returnVal = 'You should only use alphabets (a to z)'
        this.nameValid = false
      } else {
        returnVal = ''
        if (this.name?.dirty || this.name?.touched) {
          this.nameValid = true
        }
      }
    }

    return returnVal
  }
  emailIdValid!: boolean
  isCustomerEmailValid() {
    let returnVal = ''
    if (this.emailId?.invalid && (this.emailId?.dirty || this.emailId?.touched)) {
      this.emailIdValid = false
      if (this.emailId?.errors?.['required'])
        returnVal = 'Email is required'
      else if (this.emailId?.errors?.['pattern'])
        returnVal = 'Please enter a valid email ID'
      else
        returnVal = 'Please enter a valid email ID'
    } else {
      returnVal = ''
      if (this.emailId?.dirty || this.emailId?.touched) {
        this.emailIdValid = true
      }
    }

    return returnVal
  }
  SingleDetailedInvitation!: boolean
  isSingleDetailedInvitationValid() {
    let returnVal = ''

    if (this.isSingleDetailedInvitation?.invalid && (this.isSingleDetailedInvitation?.dirty || this.isSingleDetailedInvitation?.touched)) {
      this.SingleDetailedInvitation = false
      if (this.isSingleDetailedInvitation?.errors?.['required'])
        returnVal = 'Field is required'
      else
        returnVal = 'Please select a valid Input'
    } else {
      returnVal = ''
      if (this.isSingleDetailedInvitation?.dirty || this.isSingleDetailedInvitation?.touched) {
        this.SingleDetailedInvitation = true
      }
    }

    return returnVal
  }

  invitationChannel!: boolean
  isinvitationChannelValid() {
    let returnVal = ''
    if (this.isInvitationChannel?.invalid && (this.isInvitationChannel?.dirty || this.isInvitationChannel?.touched)) {
      this.invitationChannel = false
      if (this.isInvitationChannel?.errors?.['required'])
        returnVal = 'Field is required'
      else
        returnVal = 'Please select a valid Input'
    } else {
      returnVal = ''
      if (this.isInvitationChannel?.dirty || this.isInvitationChannel?.touched) {
        this.invitationChannel = true
      }
    }
    return returnVal
  }


  isnumberOfInvValid!: boolean
  isnumberOfInvitationsValid() {
    let returnVal = ''

    if (this.numberOfInvitations?.invalid && (this.numberOfInvitations?.dirty || this.numberOfInvitations?.touched)) {
      this.isnumberOfInvValid = false
      if (this.numberOfInvitations?.errors?.['required'])
        returnVal = 'Filed is required'
      else
        returnVal = 'Please select a valid Input'
    } else {
      returnVal = ''
      if (this.numberOfInvitations?.dirty || this.numberOfInvitations?.touched) {
        this.isnumberOfInvValid = true
      }
    }

    return returnVal
  }
  mobileNumberValid!: boolean
  ismobileNumberValid() {
    let returnVal = ''
    if (this.mobileNumber?.invalid && (this.mobileNumber?.dirty || this.mobileNumber?.touched)) {
      this.mobileNumberValid = false
      if (this.mobileNumber?.errors?.['required'])
        returnVal = 'Mobile number is required'
      else if (this.mobileNumber?.value == undefined ||
        (this.mobileNumber?.value.substr(0, 1) !== '+' &&
          this.mobileNumber?.dirty)) {
        returnVal = 'Mobile number must start with + and country code'
        this.mobileNumberValid = false
      }
      else if (this.mobileNumber?.errors?.['pattern'])
        returnVal = 'Please enter a Number(0-9)'
      else if (!this.mobileNumber?.errors?.['maxLength'])
        returnVal = 'Mobile no must be at least 20 characters long'
      else
        returnVal = 'Please enter a valid mobile number(+9999999999999)'
    }
    else {
      if (this.mobileNumber?.value == undefined || (this.mobileNumber?.value.substr(0, 1) !== '+' && this.mobileNumber?.dirty)) {
        returnVal = 'Mobile number must start with + and country code e.g. +971'
        this.mobileNumberValid = false
      }
      else {
        returnVal = ''
        if (this.mobileNumber?.dirty || this.mobileNumber?.touched) {
          this.mobileNumberValid = true
        }
      }
    }

    return returnVal
  }
  tagValid!: boolean
  istagValid() {
    let returnVal = ''

    if (this.tag?.invalid && (this.tag?.dirty || this.tag?.touched)) {
      this.tagValid = false
      if (this.tag?.errors?.['required'])
        returnVal = 'Field is required'
      else
        returnVal = 'Please select a valid Invitation'
    } else {
      returnVal = ''
      if (this.tag?.dirty || this.tag?.touched) {
        this.tagValid = true
      }
    }

    return returnVal
  }
  userTypeValid!: boolean
  isuserTypeValid() {
    let returnVal = ''

    if (this.userType?.invalid && (this.userType?.dirty || this.userType?.touched)) {
      this.userTypeValid = false
      if (this.userType?.errors?.['required'])
        returnVal = 'Field is required'
      else
        returnVal = 'Please select a valid Invitation'
    } else {
      returnVal = ''
      if (this.userType?.dirty || this.userType?.touched) {
        this.userTypeValid = true
      }
    }

    return returnVal
  }
  dateOfBirthvValid!: boolean
  isdateOfBirthvValid() {
    let returnVal = ''

    if (this.dateOfBirthv?.invalid && (this.dateOfBirthv?.dirty || this.dateOfBirthv?.touched)) {
      this.dateOfBirthvValid = false
      if (this.dateOfBirthv?.errors?.['required'])
        returnVal = 'Field is required'
      else
        returnVal = 'Please select a valid Input'
    } else {
      returnVal = ''
      if (this.dateOfBirthv?.dirty || this.dateOfBirthv?.touched) {
        this.dateOfBirthvValid = true
      }
    }

    return returnVal
  }
  genderIdValid!: boolean
  isgenderIdValid() {
    let returnVal = ''

    if (this.genderId?.invalid && (this.genderId?.dirty || this.genderId?.touched)) {
      this.genderIdValid = false
      if (this.genderId?.errors?.['required'])
        returnVal = 'Field is required'
      else
        returnVal = 'Please select a valid Invitation'
    } else {
      returnVal = ''
      if (this.genderId?.dirty || this.genderId?.touched) {
        this.genderIdValid = true
      }
    }

    return returnVal
  }
  idTypeValid!: boolean
  isidTypeValid() {
    let returnVal = ''

    if (this.idType?.invalid && (this.idType?.dirty || this.idType?.touched)) {
      this.idTypeValid = false
      if (this.idType?.errors?.['required'])
        returnVal = 'Field is required'
      else
        returnVal = 'Please select a valid Invitation'
    } else {
      returnVal = ''
      if (this.idType?.dirty || this.idType?.touched) {
        this.idTypeValid = true
      }
    }

    return returnVal
  }
  idNumberValid!: boolean

  isidNumberValid() {
    let returnVal = ''
    //let regIdType = new RegExp('^(?=.*[A-Z])(?=.*[0-9])[A-Z0-9]+$')
    let regIdType = new RegExp('^[A-Za-z0-9]*$')
    let regEmIdType = new RegExp('^[0-9]*$')
    if (this.idNumber?.invalid && (this.idNumber?.dirty || this.idNumber?.touched)) {
      this.idNumberValid = false
      if (this.idNumber?.errors?.['required'])
        returnVal = 'ID number is required'
      else if (this.idNumber?.errors?.['minlength'])
        returnVal = 'Name must be at least 5 characters long'

      else
        returnVal = 'Please enter a valid ID number'
    } else {
      if (!regIdType.test(this.idNumber?.value) && this.idNumber?.value === "Passport" && this.idNumber?.touched) {
        returnVal = 'Please enter only alphabet and Numbers!'
        this.idNumberValid = false
      }
      else if (!regEmIdType.test(this.idNumber?.value) && this.idNumber?.value === "Emirates ID" && this.idNumber?.touched) {
        returnVal = 'Please enter only Numbers'
        this.idNumberValid = false
      }
      else {
        //this.customerIDNumberValid = true
        returnVal = ''

        if (this.idNumber?.dirty || this.idNumber?.touched) {
          this.idNumberValid = true
        }
      }

    }

    return returnVal
  }
  countryIdValid!: boolean
  iscountryIdValid() {
    let returnVal = ''

    if (this.countryId?.invalid && (this.countryId?.dirty || this.countryId?.touched)) {
      this.countryIdValid = false
      if (this.countryId?.errors?.['required'])
        returnVal = 'Field is required'
      else
        returnVal = 'Please select a valid Invitation'
    } else {
      returnVal = ''
      if (this.countryId?.dirty || this.countryId?.touched) {
        this.countryIdValid = true
      }
    }

    return returnVal
  }
  addressLine1Valid!: boolean
  isaddressLine1Valid() {
    let returnVal = ''

    if (this.addressLine1?.invalid && (this.addressLine1?.dirty || this.addressLine1?.touched)) {
      this.addressLine1Valid = false
      if (this.addressLine1?.errors?.['required'])
        returnVal = 'Field is required'
      else
        returnVal = 'Please select a valid Invitation'
    } else {
      returnVal = ''
      if (this.addressLine1?.dirty || this.addressLine1?.touched) {
        this.addressLine1Valid = true
      }
    }

    return returnVal
  }
  addressLine2Valid!: boolean
  isaddressLine2Valid() {
    let returnVal = ''

    if (this.addressLine2?.invalid && (this.addressLine2?.dirty || this.addressLine2?.touched)) {
      this.addressLine2Valid = false
      if (this.addressLine2?.errors?.['required'])
        returnVal = 'Field is required'
      else
        returnVal = 'Please select a valid Invitation'
    } else {
      returnVal = ''
      if (this.addressLine2?.dirty || this.addressLine2?.touched) {
        this.addressLine2Valid = true
      }
    }

    return returnVal
  }
  cityValid!: boolean
  iscityValid() {
    let returnVal = ''

    if (this.city?.invalid && (this.city?.dirty || this.city?.touched)) {
      this.cityValid = false
      if (this.city?.errors?.['required'])
        returnVal = 'Field is required'
      else
        returnVal = 'Please select a valid Invitation'
    } else {
      returnVal = ''
      if (this.city?.dirty || this.city?.touched) {
        this.cityValid = true
      }
    }

    return returnVal
  }
  stateValid!: boolean
  isstateValid() {
    let returnVal = ''

    if (this.state?.invalid && (this.state?.dirty || this.state?.touched)) {
      this.stateValid = false
      if (this.state?.errors?.['required'])
        returnVal = 'Field is required'
      else
        returnVal = 'Please select a valid Invitation'
    } else {
      returnVal = ''
      if (this.state?.dirty || this.state?.touched) {
        this.stateValid = true
      }
    }

    return returnVal
  }
  postalCodeValid!: boolean
  ispostalCodeValid() {
    let returnVal = ''

    if (this.postalCode?.invalid && (this.postalCode?.dirty || this.postalCode?.touched)) {
      this.postalCodeValid = false
      if (this.postalCode?.errors?.['required'])
        returnVal = 'Field is required'
      else
        returnVal = 'Please select a valid Invitation'
    } else {
      returnVal = ''
      if (this.postalCode?.dirty || this.postalCode?.touched) {
        this.postalCodeValid = true
      }
    }

    return returnVal
  }
  sourceOfIncomeValid!: boolean
  issourceOfIncomeValid() {
    let returnVal = ''

    if (this.sourceOfIncome?.invalid && (this.sourceOfIncome?.dirty || this.sourceOfIncome?.touched)) {
      this.sourceOfIncomeValid = false
      if (this.sourceOfIncome?.errors?.['required'])
        returnVal = 'Field is required'
      else
        returnVal = 'Please select a valid Invitation'
    } else {
      returnVal = ''
      if (this.sourceOfIncome?.dirty || this.sourceOfIncome?.touched) {
        this.sourceOfIncomeValid = true
      }
    }

    return returnVal
  }
  showOtherIncomeSource!: boolean

  onIncomeSourceChange(event: any) {

    this.invitationForm.get('otherSourceOfIncome')?.setValue('');

    const selectedValue = event.target.value;

    this.showOtherIncomeSource = selectedValue === 'Other';
  }

  incomeRangeValid!: boolean
  isincomeRangeValid() {
    let returnVal = ''

    if (this.incomeRange?.invalid && (this.incomeRange?.dirty || this.incomeRange?.touched)) {
      this.incomeRangeValid = false
      if (this.incomeRange?.errors?.['required'])
        returnVal = 'Field is required'
      else
        returnVal = 'Please select a valid Invitation'
    } else {
      returnVal = ''
      if (this.incomeRange?.dirty || this.incomeRange?.touched) {
        this.incomeRangeValid = true
      }
    }

    return returnVal
  }
  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }
  isMobileNumberValid(): { isValid: boolean; message: string,validMobileNumber: string }  {  
    const mobileNumber = this.invitationForm.value?.mobileNumber;
    const dialCode = this.invitationForm.value?.dialCode;
    const selectedCountry = this.countryList?.dhabiCountries?.find(
      (c) => c.dialCode === dialCode
    );

    const length = selectedCountry?.regexForphone; 
    const regex = new RegExp(`^\\d{${length}}$`);
    const isValid = regex.test(mobileNumber);
  
    if (!isValid) { 
      const exampleNumber = `+${dialCode}${'X'.repeat(Number(length))}`;
      return {
        isValid: false,
        message: `Please enter a valid mobile number. e.g. ${exampleNumber}`,
        validMobileNumber: ''
      };
    }
    return { isValid: true, message: '',validMobileNumber:`+${dialCode}${mobileNumber}` };
  }
  InvitationValue: any = []
  isQrCodeInvite: boolean = false
  getsourceofIcomeVal() {

    let otherSourceIncomeReturnVal;
    otherSourceIncomeReturnVal = this.invitationForm.value.sourceOfIncome === "Other"
      ? "Other-" + this.invitationForm.value.otherSourceOfIncome
      : this.invitationForm.value.sourceOfIncome;

    return otherSourceIncomeReturnVal
  }
  validateIdType(formValues: any): boolean {
    let idTypeValue = formValues.idType;
    let idNumberValue = formValues.idNumber;

    let returnVal = true;

    const emiratesIDPattern = /^784\d{12}$/;
    const passportPattern = /^[A-Z0-9]{5,9}$/;
    
    if (idTypeValue === "Emirates ID" && (!emiratesIDPattern.test(idNumberValue))) {
      this.showAlertBox('Sorry', 'Enter valid Emirates ID. e.g. 784xxxxxxxxxxxx');
      returnVal = false;
      return returnVal;
    }
    else if (idTypeValue === "Passport" && (!passportPattern.test(idNumberValue))) {
      this.showAlertBox('Sorry', 'Enter a valid passport number (5–9 alphanumeric characters)');
      returnVal = false;
      return returnVal;
    }
    else {
      formValues.idNumber = '';
      //this.invitationForm.get('idNumber')?.setValue('');
      returnVal = true;
    }

    return returnVal;
  }
  submit() {    

    // if (this.invitationForm.invalid) {
    //   this.invitationForm.markAllAsTouched(); // Mark all fields as touched to show validation errors
    //   return; // Stop execution if the form is invalid
    // }

    const formValues = this.invitationForm.value;
    var mobileNumber = '';
    if (!formValues.isInvitationChannel) {
      this.showAlertBox('Sorry', 'Please Select Invitation Channel');
      this.invitationForm.markAllAsTouched();
      return;
    }
    
    if (!formValues.emailId && this.emailId?.invalid)
    {
      this.showAlertBox('Sorry', 'Please Enter Valid Email ID. e.g. abc@abc.com');
      return;
    } 
    else  {
      let resp = this.isCustomerEmailValid();
      if(resp !='')
        {
          this.showAlertBox('Sorry', 'Please Enter Valid Email ID. e.g. abc@abc.com');
          return;
        }
    }

    if (formValues.isInvitationChannel === 'sms') {
      if (!formValues.mobileNumber) {
        this.showAlertBox('Sorry', 'Please Enter Mobile Number');
        return;
      }
    
      const validationResult = this.isMobileNumberValid();

      if (!validationResult.isValid) {
        this.showAlertBox('Sorry', validationResult.message);
        return;
      }

      mobileNumber = validationResult.validMobileNumber;
    } else { 
      if (formValues.dialCode && formValues.mobileNumber) {
        const validationResult = this.isMobileNumberValid();
        if (!validationResult.isValid)  {
          this.showAlertBox('Sorry', validationResult.message);
          return;
        }

        mobileNumber = validationResult.validMobileNumber;
      }
    }


    if (formValues.numberOfInvitations > 20) {
      this.showAlertBox('Sorry', 'Invitation should be less than 20.');
      return;
    }
    
    if (formValues.sourceOfIncome === 'Other' && !formValues.otherSourceOfIncome) {
      this.showAlertBox('Sorry', 'Please enter the other income source');
      return;
    }
    
    if(formValues.sourceOfIncome === 'Other' && formValues.otherSourceOfIncome !== "") {
      const regIdType = new RegExp('^[a-zA-Z0-9\\s-]*$');
      if(!regIdType.test(formValues.otherSourceOfIncome)) {
          this.showAlertBox('Sorry', 'Please enter only alphabet and Numbers! e.g. (Income 123)');
          return;
      }
    }

    if (!this.validateIdType(formValues)) return;

    let dobValue = null;
    const dob = formValues?.dateOfBirth;

    if (dob) {
      const year = dob.getFullYear();
      const month = ('0' + (dob.getMonth() + 1)).slice(-2);
      const day = ('0' + dob.getDate()).slice(-2);
      dobValue = `${year}-${month}-${day}`;
    }

    const payload = {
      isSingleDetailedInvitation: formValues.isSingleDetailedInvitation === 'true',
      numberOfInvitations: formValues.isSingleDetailedInvitation === 'true' ? 0 : Number(formValues.numberOfInvitations),
      tag: formValues.tag,
      invitationChannel: formValues.isInvitationChannel,
      invitationDetails: {
        userType: 1,
        name: formValues.name,
        emailId: formValues.emailId,
        mobileNumber: mobileNumber,
        dateOfBirth: dobValue,
        genderId: Number(formValues.genderId),
        idType: Number(formValues.idType),
        idNumber: formValues.idNumber,
        countryId: Number(formValues.countryId),
        addressLine1: formValues.addressLine1,
        addressLine2: formValues.addressLine2,
        city: formValues.city,
        state: formValues.state,
        postalCode: formValues.postalCode,
        sourceOfIncome: this.getsourceofIcomeVal(),
        incomeRange: formValues.incomeRange
      }
    };
    

    
    this.restApi.createInvitation(payload).subscribe({
      next: (v: CreateInvitation) => {        
        if (v.success) {
          
          this.isQrCodeInvite = formValues.isInvitationChannel === 'qrCode';

          this.InvitationValue = v.invitationCodes.map((item, userId) => {
            const _selected = this.selectedItems.includes(userId);
            return { ...item, _selected };
          });

          this.openModal();
          this.changeDetector.detectChanges();
        } else {
          
          this.showAlertBox('Sorry', v.message);
        }
      },
      error: (e) => {
        
        this.showAlertBox('Sorry', 'An error occurred while creating the invitation.');
      }
    });
  }

  IncomeSourcesValue: any = []
  incomeSources() {
    this.restApi.getIncomeSource().subscribe({
      next: (v: IncomeSourcesValue) => {
        if (v.success) {

          this.IncomeSourcesValue = v.incomeSources.map((item, UserId) => {
            const _selected = this.selectedItems.includes(UserId);
            return {
              ...item,
              _selected
            };
          })

        }
      },
      error: (e) => {

      }
    })
  }

  // Alert buttons
  bAlert = false
  alertHeaderText = ""
  alertBodyText = ""
  bShowSecondAlertButton = false
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any
  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {}) {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bShowSecondAlertButton = showSecondButton
    this.alertSecondButtonText = secondButtonText
    this.alertCloseButtonText = closeButtonText
    this.alertBoxData = data
    this.bAlert = true
  }

  onAlertButtonClick(event: any) { }

  openModal() {
    this.showInvitationdataMultiple = true;
    this.changeDetector.detectChanges(); // Trigger change detection
  }

  closeReasonModal() {
    // this.route.navigate(['home/app-invitations'])
    this.invitationForm.reset()
    this.changeDetector.detectChanges(); // Trigger change detection
    this.invitationForm.patchValue({ countryId: 1, idType: '' });
    this.changeId('NA');
    this.showInvitationdata = false
    this.showInvitationdataMultiple = false
  }

  closeAlert(event: any) {
    this.bAlert = event.state
  }

  alertVisibility(event: any) {
    this.bAlert = event.state
  }
  hideForm: boolean = false
  InvitationChannelEvent(event: any) {
    if (event !== "null") {
      this.numberInvitations = false
      this.hideForm = true
    }
    else if (event === 'null') {
      this.invitationForm.reset()
      this.numberInvitations = false
      this.hideForm = false
    }
    else if (event === "false") {
      this.numberInvitations = true
      this.hideForm = false
    }
  }

  view: boolean = false;
  changeId(event: any) {
    console.log(event)
    if (event === "NA") {
      this.view = false;
    } else {
      this.view = true;
    }

  }

  printModalContent() {
  const printContent = this.InvitationValue[0].base64QRCode;

  const WindowPrt = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

  if (WindowPrt) {
    WindowPrt.document.write('<html><head><title>Print</title>');
    WindowPrt.document.write('<style>');
    WindowPrt.document.write('body { margin: 0; padding: 20px; }');
    WindowPrt.document.write('img { width: 100%; height: auto; max-width: 100%; }');
    WindowPrt.document.write('@media print { body { margin: 0; } }');
    WindowPrt.document.write('</style>');
    WindowPrt.document.write('</head><body>');
    WindowPrt.document.write(`<img id="qrImage" src="data:image/png;base64,${printContent}" alt="QR Code" />`);
    WindowPrt.document.write('</body></html>');
    WindowPrt.document.close();
    WindowPrt.onload = () => {
      setTimeout(() => {
        WindowPrt.focus();
        WindowPrt.print();
        WindowPrt.close();
      }, 500); // 500ms delay (adjust if needed)
    };
  } else {
    console.error('Failed to open print window.');
  }
} 
}
